/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { PeopleProfile } from './peopleProfile';

export type GenericApiResponsePeopleProfileData = PeopleProfile | null;
